import { render, staticRenderFns } from "./PaymentQr.vue?vue&type=template&id=6ae13eef&scoped=true&"
import script from "./PaymentQr.vue?vue&type=script&lang=js&"
export * from "./PaymentQr.vue?vue&type=script&lang=js&"
import style0 from "./PaymentQr.vue?vue&type=style&index=0&id=6ae13eef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae13eef",
  null
  
)

export default component.exports